<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="confirm-body">
                    <span v-html="$t(`message.caution_app_control_confirm_message_${dialogData.action}`)"></span>
                </div>
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')"
                        v-t="'message.button_cancel'"></el-button>
                    <el-button :class="{
                        'dialog-ok-button-dangerous': dialogData.action === 'termination',
                        'dialog-ok-button': dialogData.action === 'launch',
                    }" type="button" @click="$emit(dialogData.emit, dialogData.payload)">
                        <span v-t="$t('message.button_yes')">
                        </span>
                    </el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['dialogData'],
    data() {
        return {};
    },
    methods: {}
}
</script>

<style scoped>
.dialog-ok-button-dangerous {
    display: inline-block;
}

.el-button.dialog-ok-button-dangerous {
    font-size: 14px;
    height: 36px;
    min-width: 104px;
    padding: 0px 10px 0px 10px;
    color: #ffffff;
    background-color: #d55169;
    display: inline-block;
    border-color: #d55169;
}

.el-button.dialog-ok-button-dangerous:hover,
.el-button.dialog-ok-button-dangerous:active,
.el-button.dialog-ok-button-dangerous:focus {
    color: #ffffff;
    background-color: #d55169;
    border-color: #d55169;
    opacity: 0.8;
}
</style>
